import ImgCon from '@/business/blockchain/img-con.vue';
import IndustrialModelItem from '@/business/mechanism-model/industrial-model-item.vue';
import NumCon from '@/business/blockchain/num-con.vue';
export default {
  name: 'CTitleCard',
  components: {
    ImgCon,
    IndustrialModelItem,
    NumCon
  },
  props: {
    name: {
      // 组件名
      type: String,
      default: ''
    },
    bindprop: {
      type: Object,
      default: () => {}
    },
    title: {
      // 标题名
      type: String,
      default: ''
    },
    titleprop: {
      type: Object,
      default: () => {}
    },
    columns: {
      type: String,
      default: '1fr 1fr 1fr'
    },
    list: {
      type: Array,
      default: () => []
    }
  }
};